export default "__VITE_ASSET__B4MJpC_K__"